var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('chart-card',{attrs:{"chart":_vm.chartOptions,"constructor-type":"mapChart"}})
}
var staticRenderFns = []

export { render, staticRenderFns }